import { safeJson } from '@/scripts/utils';
import SysText from '../../sysText';

const GroupCreateMessage = memo(
  ({ payload, noStyle }: { payload: string; noStyle?: boolean }) => {
    const { user_name } = safeJson(payload, {} as any);
    return (
      <SysText noStyle={noStyle}>
        <Trans
          values={{
            name: user_name,
          }}
          i18nKey="messages.chat.message.group.groupCreate"
        />
      </SysText>
    );
  }
);
export default GroupCreateMessage;
